document.addEventListener('click', (event) => {
  const details = event.target.closest('details[data-mobile-menu]');
  document.querySelectorAll('details[data-mobile-menu][open]').forEach((menu) => {
    if (menu !== details && !menu.contains(event.target)) menu.removeAttribute('open');
  });
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sort-select]')) event.target.form.submit();
  if (event.target.matches('[data-mother-select]')) {
    const selectedMother = event.target.value;
    const items = [...document.querySelectorAll('[data-mother]')];
    let visibleCount = 0;
    items.forEach((item) => {
      const visible = !selectedMother || item.dataset.mother === selectedMother;
      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    const count = document.querySelector('[data-collection-count]');
    if (count) count.textContent = `${visibleCount} available ${visibleCount === 1 ? 'listing' : 'listings'}`;
    const empty = document.querySelector('[data-mother-empty]');
    if (empty) empty.hidden = visibleCount > 0;
  }
});
